'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/secondsUntil.js
// module id = 590
// module chunks = 0